
var id = "greySure";
var markup = "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"greySure\">\n    <title></title>\n    <defs>\n        <path d=\"M10,0 C4.48,0 0,4.48 0,10 C0,15.52 4.48,20 10,20 C15.52,20 20,15.52 20,10 C20,4.48 15.52,0 10,0 Z M8,15 L3,10 L4.41,8.59 L8,12.17 L15.59,4.58 L17,6 L8,15 Z\" id=\"greySure_path-1\" />\n    </defs>\n    <g id=\"greySure_Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"greySure_----------------——-优惠券-未关联\" transform=\"translate(-344.000000, -491.000000)\">\n            <g id=\"greySure_编组-18\" transform=\"translate(312.000000, 467.000000)\">\n                <g id=\"greySure_标题\" transform=\"translate(32.000000, 24.000000)\">\n                    <g id=\"greySure_34.-Icons/filled/action/check_circle_24px\" transform=\"translate(2.000000, 2.000000)\">\n                        <mask id=\"greySure_mask-2\" fill=\"white\">\n                            <use xlink:href=\"#greySure_path-1\" />\n                        </mask>\n                        <use id=\"greySure_icon/action/check_circle_24px\" fill=\"#999999\" xlink:href=\"#greySure_path-1\" />\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
